import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import ArtistFormFields from "./ArtistFormFields";
import { useArtistDetail } from "../../../hooks/useArtistDetail";
import { useUpdateArtist } from "../../../hooks/useUpdateArtist";
import type { ArtistDto } from "../../../api/artistsApi";

export default function ArtistEditPage() {
  const { id = "" } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const detail = useArtistDetail(id);
  const update = useUpdateArtist(id);
  const [draft, setDraft] = useState<ArtistDto | null>(null);

  useEffect(() => {
    if (!detail.data) return;
    const a = detail.data;
    setDraft({
      name: a.name,
      description: a.description ?? "",
      photoLink: a.photoLink ?? "",
      lieuIds: (a.lieux ?? []).map((l) => l.id),
    });
  }, [detail.data]);

  if (detail.isLoading) return <div className="bo-loading">Chargement…</div>;
  if (detail.isError || !detail.data)
    return <div className="bo-error-text" style={{ textAlign: "center" }}>Artiste introuvable.</div>;
  if (!draft) return null;

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    update.mutate(draft);
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title={detail.data.name}
        description="Modifier les informations de l'artiste et ses lieux d'exposition."
        actions={
          <Button type="button" variant="ghost" onClick={() => navigate("/admin/artists")}>
            ← Tous les artistes
          </Button>
        }
      />
      <div className="bo-card">
        <ArtistFormFields value={draft} onChange={setDraft} attachedLieux={detail.data.lieux ?? []} />
      </div>
      <div style={{ marginTop: "var(--sp-5)", display: "flex", justifyContent: "flex-end" }}>
        <Button type="submit" variant="primary" loading={update.isPending}>
          Enregistrer
        </Button>
      </div>
      {update.isSuccess && <p className="bo-success-text">Artiste mis à jour.</p>}
      {update.isError && <p className="bo-error-text">Erreur : {(update.error as Error)?.message}</p>}
    </form>
  );
}
